/** "Rahul Mehta" → "RM"; "Rahul" → "RA"; "QA check (Claude)" → "QC". Letters and digits only. */
export function initials(name: string): string {
  const words = name
    .trim()
    .split(/\s+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean);
  const first = words[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1] ?? '') : '';
  const letters = last ? `${first.charAt(0)}${last.charAt(0)}` : first.slice(0, 2);
  return letters.toUpperCase() || '?';
}

export function fullName(firstName: string, lastName: string | null): string {
  return lastName ? `${firstName} ${lastName}` : firstName;
}

/** `pluralize(1, 'member')` → "1 member"; `pluralize(3, 'member')` → "3 members". */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count.toLocaleString('en-IN')} ${count === 1 ? singular : plural}`;
}

export function formatCount(count: number): string {
  return count.toLocaleString('en-IN');
}

/** "follow_up" → "Follow up". Features map enum values to proper labels; this is a fallback. */
export function humanize(value: string): string {
  const text = value.replace(/[_-]+/g, ' ');
  return text.charAt(0).toUpperCase() + text.slice(1);
}
